import { render, staticRenderFns } from "./asignPtosTiendas.vue?vue&type=template&id=f933bb82&scoped=true&"
import script from "./asignPtosTiendas.vue?vue&type=script&lang=js&"
export * from "./asignPtosTiendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f933bb82",
  null
  
)

export default component.exports